import { useMutation } from "react-query";
import { defaultHeaders, getBaseUrl } from "../utils";

const usePostUserSignin = ({ mutationConfig, }: { mutationConfig: any }) => {
  const mutationFn = (data: { password: string, userName: string }) => fetch(`${getBaseUrl()}/api/auth/login`, {
    body: JSON.stringify(data), headers: defaultHeaders, method: 'POST',
  }).then(async (response: Response) => {
    const data: any = await response.json();
    /**
    * This `login` is an 'old' endpoint. When an invalid password is POSTed, it returns
    * a 200 with the error in the body of the response. We will throw it here and
    * handle the error in the useMutation hook theat sends this error
    */
    if (data.error) {
      throw data
    }

    return { data, resHeaders: response.headers };
  })
  return useMutation(mutationFn, mutationConfig)
}

export default usePostUserSignin;